import BaseAPI from './base'
/**
 * API quản lý bài kiểm tra của học sinh
 */
class StudentExamAPI extends BaseAPI {}

export default new StudentExamAPI('v1/student-exam', 'StudentExam')
